export default function initSpringBanner() {
    const now = new Date().getTime();

    const dateRange = {
      start: new Date(Date.parse('2025-05-19T01:00:00-08:00')).getTime(),
      end: new Date(Date.parse('2025-05-31T23:59:59-08:00')).getTime(),
    };
    
    const show = now >= dateRange.start && now < dateRange.end;
  
    if (show) {
      
      $('.spring-banner').show();
      $('body').addClass('banner-event');
    } else {
      $('.spring-banner').hide();
      $('body').removeClass('banner-event');
    }
  }
  